import { Column } from 'primereact/column'
import React, { useEffect } from 'react'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { CustomCheckbox, CustomDataTableHeader, CustomPanel } from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import useFaixasKm, { LOAD_MESSAGE } from './FaixasKmHook'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import FaixasKmModal from './FaixasKmModal'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'

function FaixasKm({ history, selectedTp, dispatch }) {
  const { state, localDispatch } = useFaixasKm()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.LOADING:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.loadFaixaKm(selectedTp)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetErrorMessage()
    }
  }, [state.errorMessage])

  return (
    <div style={{ marginTop: 20 }}>
      <CustomPanel onNovo={() => localDispatch.onBtnNovo(selectedTp)} onVoltar={history.goBack}>
        <div className="p-grid">
          <div className="p-col-12">
            <DataTable
              value={state.faixasKm}
              header={
                <CustomDataTableHeader
                  onChange={value => localDispatch.onGlobalFilterChange(value)}
                />
              }
              emptyMessage={'Não existe faixas de km cadastradas . . .'}
              globalFilter={state.globalFilter}
              paginator={true}
              rows={10}
              selectionMode="single"
              onSelectionChange={e => localDispatch.onDataTableItemClicked(e.value)}
            >
              <Column field="id" header="Código" style={tableCellCentered(80)} />
              <Column field="name" header="Nome" />
              <Column
                field="cities"
                header="Qtd. Cidades Selecionadas"
                style={tableCellCentered(400)}
                body={item => {
                  return item.cities.length
                }}
              />
              <Column
                field="actived"
                header="Ativo"
                style={tableCellCentered(80)}
                body={faixaskm => (
                <CustomCheckbox onChange={() => {}} checked={faixaskm.actived} />
                )}
              />
            </DataTable>
          </div>
        </div>
      </CustomPanel>
      <FaixasKmModal
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        data={state.modal.data}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(FaixasKm))
